<template>
    <section class="page-content settings">
        <div class="wrap btn-position-wrap">
            <div class="users-settings-list">
                <div class="row">
                    <div class="col-12">
                        <div class="item-wrap">
                            <div class="line-item hovered-line list-group-item btn-visible">
                                <div class="left-item">
                                    <div class="el user-item">
                                        <span class="boldContent">  Email ID </span>
                                    </div>
                                    <div class="el email-item">
                                        <span class="email-link boldContent"> Date Logged In </span>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <span class="boldContent">Time of Log In</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="item-wrap" v-for="usermanual in UserManualList" :key="usermanual.email">
                            <div class="line-item hovered-line list-group-item btn-visible">
                                <div class="left-item">
                                    <div class="el user-item">
                                        <h3>{{ usermanual.email }}</h3>
                                    </div>
                                    <div class="el email-item">
                                        <span class="email-link">{{ usermanual.dateLogIn }}</span>
                                    </div>
                                </div>
                                <div class="right-item">
                                    <div v-if="isAdmin">
                                        <div class="el email-item">
                                            <a class="email-link">{{ usermanual.timeOfLogIn }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {mapGetters} from 'vuex';
import {getUserActivityDetails} from '../../services/ClientService.js';

export default {
  data: () => ({
    dragging: false,
    UserManualList: [],
    clientIdCurrent: ''
  }),
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient']),
    ...mapGetters('user', ['userList', 'isAdmin', 'currentUser'])
  },
  methods: {
    async loadUserActivity () {
      if (this.currentClient) {
        this.clientIdCurrent = this.currentClient.id;
      } else {
        this.clientIdCurrent = this.currentUser.clientId;
      }
      let result = await getUserActivityDetails(this.clientIdCurrent);
      this.UserManualList = result.data;
    }
  },
  mounted () {
    this.loadUserActivity();
  }
};
</script>
<style lang="scss" scoped>
.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

    button {
        z-index: 15;
    }
}

.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-item {
    cursor: pointer;
}

.container {
    padding: 0 64px;
    max-width: 1366px;
    margin: 0 auto;
}

.users-settings-list {
    padding: 32px;
}

.Usermanual-Tab {
    background-color: rgb(0, 168, 202);
    width: 100%;
    height: 39px;
}

.redActiveManual {
    border-bottom: 2px solid #08a8ca;

}

.fontManualTab {
    color: #08a8ca;
}

input.remove-no-file-chosen {
    width: 90px;
    color: #fff;
}

.showSelectedFile {
    padding-left: 0px !important;
    padding-top: 5px;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.info-manual {
    font-size: 12px;
    margin-top: -20px;
    margin-bottom: -30px;
    overflow: hidden;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

@media only screen and (max-width: 1024px) {
    .users-settings-list .line-item {
        display: flex;
        flex-flow: row nowrap;
    }

    .users-settings-list .line-item .left-item {
        display: flex;
    }
}

@media only screen and (max-width: 768px) {
    .users-settings-list .line-item .left-item {
        flex-flow: row wrap;
    }
    .el.email-item {
        padding-left: 10px;
    }
}

.boldContent {
    font-size: 19px;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/LogInHistory.vue